// theme.js

export const colors = {
  primary: '#F7A500', // gold accent
  secondary: '#fff6d9', // light yellow background
  background: '#ffffff',
  surface: '#f9f9f9',
  text: '#222222',
  textSecondary: '#888888',
  border: '#eeeeee',
  success: '#4CAF50',
  danger: '#FF5252',
  gradientColors: ["#FF9800", "#F57C00"],
  darkGradientColors: ["#4d4d4bff", "#0e0e0eff"],
  darkless: "rgba(233, 233, 233, 0.25)"

};



export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
};

export const fonts = {
  regular: 'System',
  medium: 'System',
  bold: 'System',
};

export const theme = {
  colors,
  spacing,
  fonts,
  
};
